import '@babel/polyfill';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import { actions as authActions } from '@/store/modules/auth/types';
import axios from 'axios';
import Vue from 'vue';
// uncomment this line to enable Google Analytics tracking:
//import VueGtag from 'vue-gtag';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import './assets/stylus/main.styl';
import './assets/css/main.css';
import store from './store';
import router from './router';

// Axios global defaults

const baseURL = process.env.BASE_URL;

// ensure that api/ and auth/ are located under the  base URL e.g,. /p1/api, /p1/auth
axios.defaults.baseURL = baseURL;

// convert baseURL to unique cookie name prefix
let cookiePrefix = '';
if (baseURL) {
  const match = baseURL.match(/^\/?(.*)$/);
  if (match) {
    cookiePrefix = match[1].replace('/', '_');
  }
}

axios.defaults.xsrfCookieName = cookiePrefix + 'csrf_access_token';
axios.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

Vue.config.productionTip = false;

// Globally register the loading spinner because we
// use it in so many components.
Vue.component('LoadingSpinner', LoadingSpinner);

const authModule = 'auth';
const getUserFromSession = authActions.GET_USER_FROM_SESSION;
// This step is important. We want to wait for the store to be
// initialized and user data to be fetched before we initialize
// the application. Because checking if the user is already logged
// in is an asynchronous call, we want to wait until it finishes
// so our app can appropriately give access to certain pages.
(async () => {
  try {
    await store.dispatch(`${authModule}/${getUserFromSession}`);
  } catch (err) {
    // No active user token. We don't do anything here because router
    // will deal with sending user to sign in page.
  } finally {
    // uncomment these lines and supply a valid Gtag id to enable Google Analytics tracking:

    //    Vue.use(
    //      VueGtag,
    //      {
    //        config: { id: 'G-??????????' },   // insert Google Analytics token here
    //      },
    //      router
    //    );

    // Initialize...
    new Vue({
      vuetify,
      store,
      router,
      // catch all mouse clicks not intercepted by @click.native:
      mounted: function() {
        //        this.$el.addEventListener('click', this.onClickVue);
      },
      //      methods: {
      //        onClickVue: function(e) {
      //          console.log(
      //            'onClickVue e.target=' +
      //              e.target +
      //              ' id=' +
      //              e.target.id +
      //              ' name=' +
      //              e.target.name +
      //              ' parent=' +
      //              e.target.parentElement
      //          );
      //        },
      //    },
      render: h => h(App),
    }).$mount('#app');
  }
})();
